/* global axios */
import ApiClient from './ApiClient';

class SalvyApi extends ApiClient {
  constructor() {
    super('salvy', { accountScoped: true });
  }

  getAreaCodes() {
    return axios.get(`${this.url}/area_codes`);
  }

  createVirtualNumber(areaCode) {
    return axios.post(`${this.url}/create_virtual_number`, {
      area_code: areaCode,
    });
  }

  registerNumber(payload) {
    return axios.post(`${this.url}/register_number`, payload);
  }
}

export default new SalvyApi();
